// El marco del cartel toma la proporción de la imagen, acotada: nunca más alto que 3/4 ni
// más ancho que 4/3. Dentro de ese rango el cartel llena el marco sin bandas; fuera, entra
// entero y lo que sobra lo rellena su propio desenfoque. Misma regla que `EventPoster` en
// revopic-gallery, para que «Así se verá en la galería pública» siga siendo verdad.
export const POSTER_RATIO_MIN = 3 / 4;
export const POSTER_RATIO_MAX = 4 / 3;

export const posterRatio = (width, height) => {
    if (!width || !height) return null;
    return Math.min(POSTER_RATIO_MAX, Math.max(POSTER_RATIO_MIN, width / height));
};
